/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import { Loading, Message } from 'element-ui';
import store from '../store';
import router from '../router';
import { encrypt,decrypt } from './public'

// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading;

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "Loading...",
    background: 'rgba(0, 0, 0, 0.7)',
    target: document.querySelector('body') //设置加载动画区域
  });
}

function endLoading() {
  loading.close();
}

//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

// 请求超时时间
// axios.defaults.timeout = 10000;

// post请求头
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
  config => {
    if(config.data) {
      if (JSON.stringify(config.data) == '{}') {
        config.data = undefined
      } else if(JSON.stringify(config.data) !== '{}') {
        config.data = encrypt(JSON.stringify(config.data))
      }
    }
    if(config.params) {
      if(JSON.stringify(config.params) !== '{}') {
        for(let key in config.params){
          config.params[key] = encrypt(config.params[key]?config.params[key] : '')
        }
      } else if(JSON.stringify(config.params) == '{}') {
        config.params = undefined
      }
    }
    if(config.url != '/sys-server/open-api/water/newGet' && config.url != '/sys-server/open-api/h5/jobFairCompany/page') {
      showFullScreenLoading()
    }
    // console.log("platformInfo", store.state.platformInfo)
    const appId = store.state.platformInfo.appId;

    appId && (config.headers["App-Id"] = appId);
    appId && (config.headers["App-Id-pc"] = appId);

    return config;
  },
  error => {
    Message.error({
      message: '请求超时!'
    });
    tryHideFullScreenLoading()
    return Promise.error(error);
  })

// 响应拦截器
let show = false
axios.interceptors.response.use(
  response => {
    if(!show) {
      if(response.data.data && Object.prototype.toString.call(response.data.data ) === '[object String]'){
        let data = decrypt(response.data.data)
        try {
          response.data.data = JSON.parse(data)
        } catch (error) {
          response.data.data = data
        }
        
      }
      if (response.status === 200) {
        setTimeout(function () {
          tryHideFullScreenLoading()
        }, 300)
        return Promise.resolve(response);
      } else {
        setTimeout(function () {
          tryHideFullScreenLoading()
        }, 300)
        return Promise.reject(response);
      }
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if(!show) {
      tryHideFullScreenLoading()
      if (error.response.status) {
        switch (error.response.status) {
          // 401: 未登录
          case 401:
            localStorage.clear()
            router.replace({
              path: '/home',
            });
            break;
          // 404请求不存在
          case 404:
            Message.error({
              message: '网络请求不存在'
            });
            break;
          // 其他错误，直接抛出错误提示
          default:
            if(error.response.data.error == 'Service Unavailable' || error.response.data.error == 'Internal Server Error'){ // 服务不在线
              show = true
              Loading.service({
                lock: true,
                text: "",
                customClass:'unavailable',
                background: 'rgba(0, 0, 0, 0.7)',
                target: document.querySelector('.fillcontain'), //设置加载动画区域
              });
            }else{
              Message.error({
                message: error.response.data.msg
              });
            }
        }
        return Promise.reject(error.response);
      }
    }
  }
);
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js